


















import {Vue,Component,Prop, Watch,Mixins} from 'vue-property-decorator';
import * as letterOwnerService from '@/store/Services/letterOwnerService';
import SimpleLookupMobile from '@/components/MobileComponents/EnterpriseFormMobile/SimpleLookupMobile/SimpleLookupMobile.vue';
import { ValidValues } from '../../../../store/models/EnterpriseForm/EnterpriseFormValidValues';
import BookmarkMixin from '@/components/Cartable/EnterpriseForm/BookmarkComponents/BookmarkMixin';

@Component({
    components:{SimpleLookupMobile}
})
export default  class  PersonnelLetterOwnerListBookmarkMobile extends Mixins(BookmarkMixin){
   
    valueProp = "";
    validValues = [] as  ValidValues[];

    async created(){
        await this.setValidValues();
    }
    async setValidValues(){
        this.validValues.length = 0;
        const owners =  await letterOwnerService.getAllPersonnelLetterOwners();
        owners.forEach(o=>{
            const validVal = {} as ValidValues;
            validVal.item1 = o.id;
            validVal.item2 = o.name;
            this.validValues.push(validVal);
        });
    }
    onValueSelected(value: ValidValues){
        this.value.Id = value.item1;
        this.value.Value = value.item2;
        this.$emit("value-changed",this.englishName);
    }
    onValueChanged(){
        if(this.value)
            if(this.value.Value)
                this.valueProp = this.value.Value;
            else 
                this.valueProp = this.value;
    }
        isMandatoryValueSupplied(){
        if(!this.isMandatory)return true;
        if(this.value.Id == undefined || this.value.Value == undefined)
            return false;
        
        return true;
    }
    
    
}
